module.exports = __webpack_public_path__ + "img/2_2.5257f8e0.png";